/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Button, Card, Col, Dropdown, Image, Row, Tag } from "antd";
import { DeleteIcon } from "../../../../atoms/CustomIcons";
// import Header from "../../../../atoms/Header";
// import DashboardTemplate from "../../../../templates/Dashboard";
import EmptyCard from "../../../../atoms/EmptyCard";
import Filters from "./Components/Filters";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import { getServiceLineDetails, getServiceListing } from "../ducks/actions";
import { ServiceLineListingType, SubServiceType } from "../ducks/types";
import ConfirmDelete from "../../../../atoms/ConfirmDelete";
import { PopUp } from "../../../../atoms/PopUp";
import {
  changeServiceType,
  deleteService,
  updateServiceStatus,
} from "../ducks/services";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
import SidebarDetail from "./Components/SidebarDetail";
import { MoreOutlined } from "@ant-design/icons";
import CollapseSubService from "./Components/CollapseSubService";
import IconServices from "../../../../atoms/CustomIcons/IconServices";

export default function ServiceDetails() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [confirmSimple, SetConfirmSimple] = useState(false);
  const [confirmSub, SetConfirmSub] = useState(false);
  const [archivePopUp, setArchivePopUp] = useState(false);
  const [activeId, setActiveId] = useState<null | string>(null);
  const [activeType, setActiveType] = useState<null | string>(null);
  const [activeRecord, setActiveRecord] = useState<SubServiceType | null>(null);
  const [tableRecord, setTableRecord] = useState<ServiceLineListingType | null>(
    null
  );
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];
  const [dataSource, setDataSource] = useState<ServiceLineListingType[]>([]);
  const [value, setValue] = useState("");
  const serviceLineDetail = useAppSelector(
    (state) => state?.services?.serviceLineDetail
  );
  const serviceListing = useAppSelector(
    (state) => state?.services?.serviceListing
  );
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [filters, setFilters] = useState<{
    status: string;
    type: string | undefined;
    frequency: string | undefined;
  }>({
    status: "active",
    type: undefined,
    frequency: undefined,
  });
  const [archived, isArchived] = useState(false);

  useEffect(() => {
    if (companyId && serviceLineId) {
      const payload = {
        status: filters?.status, //active,archived
        company_id: companyId,
        service_line_id: serviceLineId,
        service_provision_type: filters?.type ?? undefined,
        frequency: filters?.frequency ?? undefined,
      };
      dispatch(getServiceLineDetails(serviceLineId));
      dispatch(getServiceListing(payload));
    }
  }, [companyId, dispatch, serviceLineId, filters]);

  const simpleItems = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/company-settings/edit-service/${tableRecord?.id}/${serviceLineId}/${companyId}`
            );
          }}
        >
          Edit
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/convert-icon.svg" preview={false} />}
          onClick={(e) => {
            SetConfirmSub(true);
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Convert to service with subservices
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={
            <Image
              src={`/images/table/${
                tableRecord?.status === "active" ? "archive" : "activate"
              }-icon.svg`}
              preview={false}
            />
          }
          onClick={(e) => {
            e.stopPropagation();
            tableRecord?.status === "active"
              ? setArchivePopUp(true)
              : archiveFunction();
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          {tableRecord?.status === "active" ? "Archive" : "Activate"}
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const subServiceItems = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/plus-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/company-settings/${tableRecord?.id}/${serviceLineId}/${companyId}`
            );
          }}
        >
          Add subservice
        </Button>
      ),
    },

    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/company-settings/edit-service/${tableRecord?.id}/${serviceLineId}/${companyId}`
            );
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "3",
      disable: tableRecord ? tableRecord?.subservices?.length > 1 : false,
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/convert-icon.svg" preview={false} />}
          onClick={(e) => {
            SetConfirmSimple(true);
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
          disabled={tableRecord ? tableRecord?.subservices?.length > 1 : false}
        >
          Convert to simple service
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={
            <Image
              src={`/images/table/${
                tableRecord?.status === "active" ? "archive" : "activate"
              }-icon.svg`}
              preview={false}
            />
          }
          onClick={(e) => {
            e.stopPropagation();
            tableRecord?.status === "active"
              ? setArchivePopUp(true)
              : archiveFunction();
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          {tableRecord?.status === "active" ? "Archive" : "Activate"}
        </Button>
      ),
    },
    {
      key: "5",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<Image src="/images/table/delete-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const archiveFunction = () => {
    setLoading(true);
    const payload = {
      status: tableRecord?.status === "active" ? "archived" : "active",
    };
    updateServiceStatus(tableRecord?.id as string, payload)
      .then(() => {
        setLoading(false);
        setArchivePopUp(false);

        const payload = {
          status: tableRecord?.status ?? "active", //active,archived
          company_id: companyId,
          service_line_id: serviceLineId,
        };
        dispatch(getServiceListing(payload));
        // SuccessMessage(
        //   `Service ${
        //     tableRecord?.status === "active" ? "archived" : "activated"
        //   }`
        // );

        SuccessMessage(
          tableRecord?.type === "simple"
            ? `Service ${
                tableRecord?.status === "active" ? "archived" : "activated"
              }`
            : `Subservice ${
                tableRecord?.status === "active" ? "archived" : "activated"
              }`
        );
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };
  const deleteFunction = () => {
    setLoading(true);
    deleteService([tableRecord?.id || ""])
      .then(() => {
        setLoading(false);
        setIsDeleteModalOpen(false);

        const payload = {
          status: "active", //active,archived
          company_id: companyId,
          service_line_id: serviceLineId,
        };
        dispatch(getServiceListing(payload));
        SuccessMessage(
          tableRecord?.type === "simple"
            ? "Service deleted"
            : "Subservice deleted"
        );
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };
  const convertSimpleFunction = () => {
    setLoading(true);
    const payload = {
      service_id: tableRecord?.id as string,
      type: "simple",
    };
    changeServiceType(payload)
      .then(() => {
        setLoading(false);
        setIsDeleteModalOpen(false);
        SetConfirmSub(false);
        SetConfirmSimple(false);

        const payload = {
          status: "active", //active,archived
          company_id: companyId,
          service_line_id: serviceLineId,
        };
        dispatch(getServiceListing(payload));
        SuccessMessage("Service converted");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };
  const convertSubFunction = () => {
    setLoading(true);
    const payload = {
      service_id: tableRecord?.id as string,
      type: "subservice",
    };
    changeServiceType(payload)
      .then(() => {
        setLoading(false);
        setIsDeleteModalOpen(false);
        SetConfirmSub(false);
        SetConfirmSimple(false);

        const payload = {
          status: "active", //active,archived
          company_id: companyId,
          service_line_id: serviceLineId,
        };
        dispatch(getServiceListing(payload));
        SuccessMessage("Service converted");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const confirmArchive = {
    visibility: archivePopUp,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => setArchivePopUp(false)}
        heading={
          tableRecord?.type === "simple"
            ? "Archive service"
            : "Archive subservice"
        }
        paragraph={
          <>
            Are you sure you want to archive <b>{tableRecord?.name}</b>?<br />
            <br />
            This {tableRecord?.type === "simple"
              ? "service"
              : "subservice"}{" "}
            won’t be available for use.
          </>
        }
        btnText={
          tableRecord?.type === "simple"
            ? "Archive service"
            : "Archive subservice"
        }
        btnApi={archiveFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setArchivePopUp(false),
  };

  const confirmDeletePopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete <b>{tableRecord?.name}</b>?<br />
            <br />
            This action cannot be undone.
          </>
        }
        btnText={
          tableRecord?.type === "simple"
            ? "Delete service"
            : "Delete subservice"
        }
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const confirmSimpleService = {
    visibility: confirmSimple,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => SetConfirmSimple(false)}
        heading="Convert to a simple service"
        paragraph={
          <>
            When a service has one subservice only, you can make it look simple
            and neat in the estimates and proposals. We recommend that. To
            confirm, please click the button below.
            <br />
            <br />
            You can switch the view back anytime.
          </>
        }
        btnText="Confirm"
        btnApi={convertSimpleFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => SetConfirmSimple(false),
  };

  const confirmSubService = {
    visibility: confirmSub,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => SetConfirmSub(false)}
        heading="Convert to a service with subservices"
        paragraph={
          <>
            Converting to a service with subservices makes it easier to manage
            when you offer multiple related service items under one main
            service.
            <br />
            <br />
            <span style={{ fontSize: 12, color: "#6C7478" }}>
              For example: Hard and Soft Edging as subservices under a single
              service — Edging.
            </span>
            <br />
            <br />
            The current service production details (like labor rates, materials,
            etc.) will be moved to its subservice.
            <br />
            <br />
            As long as there’s only one subservice, you can switch back to the
            simple service anytime.
          </>
        }
        btnText="Confirm"
        btnApi={convertSubFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => SetConfirmSub(false),
  };

  useEffect(() => {
    const currentData = serviceListing?.data;
    let filteredData: ServiceLineListingType[] = [];

    if (value && currentData) {
      filteredData = currentData?.filter((entry) => {
        const typedData = value
          ? entry?.name && entry?.name.toLowerCase().includes(value)
          : true;

        return typedData;
      });

      setDataSource(filteredData);
    } else {
      setDataSource(serviceListing?.data ?? []);
    }
  }, [value, serviceListing]);
  console.log("dataSource", dataSource);
  return (
    <>
      <div className="maxWidth services_details_page">
        <Row gutter={16} wrap={false}>
          <Col
            flex="auto"
            className="innerLeft"
            style={{ transition: "0.35s" }}
          >
            <div className="empty_wrap" style={{ padding: "32px" }}>
              <h2 className="tabs_content_heading">
                <IconServices /> Services
              </h2>
              <p
                className="tabs_content_subheading"
                style={{ marginBottom: "20px" }}
              >
                Specify service details, such as production rates, materials,
                and equipment for each service.
              </p>

              <Filters
                setFilters={setFilters}
                archived={archived}
                isArchived={isArchived}
                companyId={companyId}
                serviceLineId={serviceLineId}
                value={value}
                setValue={setValue}
                filters={filters}
              />

              <div className="serviceDetailLeftWrap">
                {dataSource && dataSource?.length > 0 ? (
                  dataSource?.map((data) => (
                    <Card
                      key={data?.id}
                      className={`${data?.type}_service_card service_detail_card`}
                    >
                      <div
                        className="top_wrap"
                        onClick={() => {
                          setActiveId(data?.id);
                          setActiveType(data?.type);
                          setActiveRecord(null);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <Avatar
                          src={data?.image_url}
                          shape="square"
                          size={36}
                        />

                        <h4
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                          }}
                        >
                          {data?.name}{" "}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Tag
                              className={
                                data?.service_provision_type === "in_house"
                                  ? "violet_tag defaultTag"
                                  : "orange_tag defaultTag"
                              }
                            >
                              {data?.service_provision_type === "in_house"
                                ? "In-house"
                                : "Subcontracted"}
                            </Tag>
                            <Tag className="defaultTag default_tag">
                              {data?.frequency !== "one_time"
                                ? "Recurring"
                                : "One-time"}
                            </Tag>
                          </div>
                        </h4>

                        <Dropdown
                          menu={{
                            items:
                              data?.type === "simple"
                                ? simpleItems
                                : subServiceItems,
                          }}
                          trigger={["click"]}
                          placement="bottomRight"
                          className="actionButton"
                        >
                          <Button
                            onClick={(e) => {
                              e.stopPropagation();
                              setTableRecord(data);
                            }}
                            onKeyDown={(e) => e.stopPropagation()}
                            style={{
                              padding: "6px",
                              height: "auto",
                              background: "transparent",
                            }}
                            className="only_icon"
                            icon={<MoreOutlined />}
                            ref={dropdownRef}
                          />
                        </Dropdown>
                      </div>
                      {data?.type === "subservice" && (
                        <CollapseSubService
                          data={data}
                          setActiveRecord={setActiveRecord}
                          setActiveType={setActiveType}
                        />
                      )}
                    </Card>
                  ))
                ) : (
                  <EmptyCard
                    h2Style={{
                      fontSize: "20px",
                      color: "#151718",
                    }}
                    pStyle={{ color: "#474C4D", fontSize: "15px" }}
                    title={
                      archived || value?.length > 0
                        ? "No results match the filter or search criteria"
                        : "No services added yet"
                    }
                    description={
                      archived || value?.length > 0
                        ? "Try adjusting the filters and search."
                        : "Set up services for Landscape maintenance by defining work details, production rates, materials, and equipment."
                    }
                    image={
                      archived || value?.length > 0
                        ? "/images/empty-icons/no-archived.svg"
                        : "/images/empty-icons/error-icon.svg"
                    }
                    className={
                      archived || value?.length > 0 ? "filter_applied" : ""
                    }
                  />
                )}
              </div>
            </div>
          </Col>
          {(activeType === "simpleSubService" || activeType === "simple") && (
            <Col
              flex={
                activeType === "simpleSubService" || activeType === "simple"
                  ? "360px"
                  : "0px"
              }
              style={{ transition: "0.35s" }}
            >
              <SidebarDetail
                data={
                  activeType === "simpleSubService"
                    ? activeRecord
                    : dataSource?.find((e) => e?.id === activeId)
                }
                setActiveId={setActiveId}
                companyId={companyId}
                serviceLineDetail={serviceLineDetail?.data}
                activeType={activeType}
                setActiveRecord={setActiveRecord}
                setActiveType={setActiveType}
              />
            </Col>
          )}
        </Row>
      </div>
      <PopUp {...confirmDeletePopUp} />
      <PopUp {...confirmSimpleService} />
      <PopUp {...confirmSubService} />
      <PopUp {...confirmArchive} />
    </>
  );
}
